import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Header from "../components/Header";
import { Ionicons } from "@expo/vector-icons";

const UserOrdersOrders = ({ navigation, route }) => {
  const [operaciones, setOperaciones] = useState([]);
  const [loading, setLoading] = useState(true);

  const clientData = route.params?.data ?? {};
  const clientName = clientData.APELLIDO ?? "Cliente";
  const clientCuit = clientData.CUIT ?? "";

  useEffect(() => {
    const fullmail = clientCuit + "@mail.com";
    getDocs(
      query(collection(db, "orders"), where("user", "==", fullmail))
    ).then((snap) => {
      const fetched = [];
      snap.forEach((doc) => fetched.push(doc.data()));
      fetched.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
      setOperaciones(fetched);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <View style={s.loadingContainer}>
        <ActivityIndicator size="large" color="#080680" />
        <Text style={s.loadingText}>Cargando pedidos...</Text>
      </View>
    );
  }

  return (
    <View style={s.container}>
      <Header title={clientName} navigation={navigation} isBack={true} />

      <View style={s.clientBanner}>
        <Ionicons name="person-outline" size={16} color="#080680" />
        <Text style={s.clientBannerText}>CUIT {clientCuit}</Text>
        <Text style={s.orderCount}>{operaciones.length} pedido{operaciones.length !== 1 ? "s" : ""}</Text>
      </View>

      <ScrollView
        style={s.scroll}
        contentContainerStyle={s.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {operaciones.length === 0 ? (
          <View style={s.emptyContainer}>
            <Ionicons name="receipt-outline" size={64} color="#ddd" />
            <Text style={s.emptyText}>Este cliente no tiene pedidos aún.</Text>
          </View>
        ) : (
          operaciones.map((item, index) => {
            const dateObj = new Date(item.fecha);
            const formattedDate = dateObj.toLocaleDateString("es-AR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            });
            const formattedTime = dateObj.toLocaleTimeString("es-AR", {
              hour: "2-digit",
              minute: "2-digit",
            });

            return (
              <TouchableOpacity
                key={index}
                style={s.card}
                onPress={() => navigation.navigate("Order", item)}
                activeOpacity={0.8}
              >
                <View style={s.cardHeader}>
                  <View style={s.dateContainer}>
                    <Ionicons name="calendar-outline" size={16} color="#666" />
                    <Text style={s.dateText}>{formattedDate}</Text>
                    <Text style={s.timeText}>{formattedTime}</Text>
                  </View>
                  <View style={[
                    s.statusBadge,
                    item.estado === "Finalizado" ? s.statusFinalizado : s.statusProcesando,
                  ]}>
                    <Text style={[
                      s.statusText,
                      item.estado === "Finalizado" ? s.statusTextFinalizado : s.statusTextProcesando,
                    ]}>
                      {item.estado || "Procesando"}
                    </Text>
                  </View>
                </View>

                <View style={s.cardContent}>
                  <View style={s.row}>
                    <Text style={s.label}>Total:</Text>
                    <Text style={s.value}>${Number(item.total).toFixed(2)}</Text>
                  </View>
                  {Array.isArray(item.items) && (
                    <View style={s.row}>
                      <Text style={s.label}>Items:</Text>
                      <Text style={s.value}>{item.items.length}</Text>
                    </View>
                  )}
                  {item.ero && Number(item.ero) > 0 && (
                    <View style={s.row}>
                      <Text style={s.label}>ERO:</Text>
                      <Text style={s.value}>${Number(item.ero).toFixed(2)}</Text>
                    </View>
                  )}
                  {item.drn && Number(item.drn) > 0 && (
                    <View style={s.row}>
                      <Text style={s.label}>DRN:</Text>
                      <Text style={s.value}>${Number(item.drn).toFixed(2)}</Text>
                    </View>
                  )}
                  {item.discount != "0" && Number(item.discount) > 0 && (
                    <View style={s.row}>
                      <Text style={s.discountLabel}>Descuento:</Text>
                      <Text style={s.discountValue}>
                        -${Number(item.discount).toFixed(2)}
                      </Text>
                    </View>
                  )}
                  {item.viajante && (
                    <View style={s.row}>
                      <Text style={s.label}>Viajante:</Text>
                      <Text style={s.viajanteValue}>{item.viajante}</Text>
                    </View>
                  )}
                </View>
              </TouchableOpacity>
            );
          })
        )}
        <View style={{ height: 40 }} />
      </ScrollView>
    </View>
  );
};

export default UserOrdersOrders;

const s = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  loadingContainer: {
    flex: 1,
    backgroundColor: "#F4F6FD",
    justifyContent: "center",
    alignItems: "center",
  },
  loadingText: {
    marginTop: 10,
    color: "#666",
  },
  clientBanner: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    backgroundColor: "#EEF0FB",
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#dde1f5",
  },
  clientBannerText: {
    flex: 1,
    fontSize: 13,
    color: "#080680",
    fontWeight: "600",
  },
  orderCount: {
    fontSize: 12,
    color: "#888",
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    padding: 16,
  },
  emptyContainer: {
    alignItems: "center",
    marginTop: 60,
  },
  emptyText: {
    marginTop: 16,
    color: "#999",
    fontSize: 16,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
    borderLeftWidth: 4,
    borderLeftColor: "#080680",
  },
  cardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#f0f0f0",
  },
  dateContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  dateText: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#333",
  },
  timeText: {
    fontSize: 14,
    color: "#888",
  },
  cardContent: {
    gap: 6,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  label: {
    fontSize: 14,
    color: "#666",
  },
  value: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
  },
  discountLabel: {
    fontSize: 14,
    color: "#4CAF50",
    fontWeight: "500",
  },
  discountValue: {
    fontSize: 14,
    fontWeight: "600",
    color: "#4CAF50",
  },
  viajanteValue: {
    fontSize: 13,
    color: "#888",
    fontStyle: "italic",
  },
  statusBadge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 20,
  },
  statusProcesando: {
    backgroundColor: "#FFF3E0",
    borderWidth: 1,
    borderColor: "#FF9800",
  },
  statusFinalizado: {
    backgroundColor: "#E8F5E9",
    borderWidth: 1,
    borderColor: "#4CAF50",
  },
  statusText: {
    fontSize: 12,
    fontWeight: "600",
  },
  statusTextProcesando: {
    color: "#E65100",
  },
  statusTextFinalizado: {
    color: "#2E7D32",
  },
});
